import { render, staticRenderFns } from "./role-pill.component.vue?vue&type=template&id=337e8a35&scoped=true"
import script from "./role-pill.component.vue?vue&type=script&lang=ts"
export * from "./role-pill.component.vue?vue&type=script&lang=ts"
import style0 from "./role-pill.component.vue?vue&type=style&index=0&id=337e8a35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337e8a35",
  null
  
)

export default component.exports